import styles from "../../styles/checkbox.module.scss";
import globals from "../../styles/globals.scss";

import { CheckIcon } from "../components/Icons";

import classNames from "classnames/bind";

export const Checkbox = ({
  checked,
  name,
  onChange,
  onClick,
  children,
  className,
  disabled,
  design = "one",
  label,
  tooltip,
}) => {
  const cx = classNames.bind(styles);
  return (
    <div
      className={cx({
        checkboxContainer: true,
        [className]: className,
        disabled: disabled,
        inactive: !onChange && !onClick,
      })}
      onClick={(e) => e.stopPropagation()}
    >
      <label htmlFor={name}>
        <input
          id={name}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={() => onChange && onChange(!checked)}
        />
        <div
          className={cx({
            checkbox: true,
            [`design-${design}`]: true,
          })}
        >
          {checked && <CheckIcon color="#fff" />}
        </div>
        {(children || label) && <span data-tooltip={tooltip}>{children || label}</span>}
      </label>

    </div>
  );
};
